export type PasswordRequirement = {
  id: string;
  label: string;
  ok: boolean;
};

// Policy:
// At least 8 characters, includes uppercase, lowercase, a number, and a symbol from @$!%*?&
const SYMBOLS_REGEX = /[!@#$%^&*(),.?":{}|<>_\-\\[\];'`~+=/]/;
const UPPERCASE_REGEX = /[A-Z]/;
const LOWERCASE_REGEX = /[a-z]/;

export const isPasswordCompliant = (password: string): boolean => {
  if (!password) return false;
  const hasLength = password.length >= 8;
  const hasUpper = UPPERCASE_REGEX.test(password);
  const hasLower = LOWERCASE_REGEX.test(password);
  const hasNumber = /\d/.test(password);
  const hasSymbol = SYMBOLS_REGEX.test(password);
  return hasLength && hasUpper && hasLower && hasNumber && hasSymbol;
};
